import SettingTypes from '@/utils/setting-types'

export default {
  name: 'news-bar',
  label: {
    title: '新闻',
    icon: require('@/assets/icon-component-label_Notice.png'),
    limit: 20
  },
  sort: 11,
  data: {
    // 新闻内容
    content: '',
    // 新闻背景颜色
    background_color: '#fff8e9',
    // 新闻内容颜色
    content_color: '#646566',
    // 新闻内容字体大小
    content_font_size: 36,
    // 页面圆角
    page_radius: 20,
    // 页面边距
    page_edge: 20,
    // 顶部距离
    page_top_edge: 0,
    // 左侧图标
    show_left_icon: false,
    // 右侧图标
    show_right_icon: false,
    // 跳转链接
    to_link: ''
  },
  settings: {
    content: {
      type: SettingTypes.input,
      label: '新闻',
      props: {
        placeholder: '请填写新闻内容'
      }
    },
    background_color: {
      type: SettingTypes.color_picker,
      label: '背景颜色',
      default: '#fff8e9'
    },
    content_color: {
      type: SettingTypes.color_picker,
      label: '文字颜色',
      default: '#646566'
    },
    content_font_size: {
      type: SettingTypes.radio_button,
      label: '文字大小',
      options: [
        { label: '大（18号）', value: 36, icon: 'rb-icon-font-x' },
        { label: '中（16号）', value: 32, icon: 'rb-icon-font-m' },
        { label: '小（14号）', value: 28, icon: 'rb-icon-font-s' }
      ]
    },
    page_edge: {
      type: SettingTypes.slider,
      label: '页面边距',
      props: {
        min: 0,
        max: 200
      }
    },
    page_radius: {
      type: SettingTypes.slider,
      label: '页面圆角',
      props: {
        min: 0,
        max: 750
      }
    },
    page_top_edge: {
      type: SettingTypes.slider,
      label: '顶部距离',
      props: {
        min: -100,
        max: 100
      }
    },
    show_left_icon: {
      type: SettingTypes.boolean,
      label: '左侧图标',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        custom_component_name: 'customLeftIcon'
      }
    },
    show_right_icon: {
      type: SettingTypes.boolean,
      label: '右侧图标',
      props: {
        activeText: '显示',
        inactiveText: '不显示'
      },
      option: {
        custom_component_name: 'customRightIcon'
      }
    },
    to_link: {
      type: SettingTypes.custom,
      component_name: 'customLink'
    }
  }
}
